import React from 'react';
import DisclosureModal from './components/DisclosureModal';
import DisclosureStore from './stores/DisclosureStore';
import OpenDisclosureModal from './components/OpenDisclosureModal';

const Disclosure = (railsProps) => {
  const store = new DisclosureStore(railsProps);
  return (
    <>
      <OpenDisclosureModal store={store} />
      <DisclosureModal store={store} />
    </>
  );
};

export default Disclosure;
